import { INIT_GET, INIT_STATUS, INIT_ACCESS_CACHE } from '../actions/init'
import apiCall from './call'

const state = {
  all: false
}

const getters = {
  authUser: state => {
    return state.all.auth_user
  }
}

const actions = {
  [INIT_GET]: ({ commit, dispatch, rootState }) => {
    commit('isLoading', { root: true })

    return new Promise((resolve, reject) => {
      apiCall({ url: 'init' })
        .then(response => {
          commit(INIT_GET, response)
          commit('doneLoading', { root: true })

          if (response.data.auth_user.via_invite) {
            dispatch('forceOpenSidebar')
          }

          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [INIT_STATUS]: ({ commit, dispatch, rootState }) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: 'status' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [INIT_ACCESS_CACHE]: ({ commit, dispatch, rootState }) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: 'init/cache' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

const mutations = {
  [INIT_GET]: (state, resp) => {
    state.all = resp.data
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/init.js